<template>
    <div class="productLine">
        <el-image
            style="width: 100%;display: block;"
            :src="$store.state.isPC?require('@/assets/img/mask2.png'):require('@/assets/img/mask2_1.png')"
            fit="contain">
        </el-image>
        <div class="lineContent">
            <div class="lineTitle fontPB">
                <div>{{$t('product.productline')}}</div>
                <div>
                    <template v-if="$store.state.language=='zh-CN'||$store.state.language=='zh-TW'">———-</template>
                    <template v-else>------- -----</template>
                </div>
            </div>
            <div class="theme fontPB">
                <div class="themeItem hv" @click="openPage('Ancient');">
                    <el-image
                        class="themeImg"
                        :src="$store.state.isPC?require('@/assets/img/ancent.png'):require('@/assets/img/ancent1.png')"
                        fit="contain">
                    </el-image>
                    <div class="themeText">{{$t('product.ancient')}}</div>
                </div>
                <div class="themeItem hv" @click="openPage('Sea');">
                    <el-image
                        class="themeImg"
                        :src="$store.state.isPC?require('@/assets/img/sea.png'):require('@/assets/img/sea1.png')"
                        fit="contain">
                    </el-image>
                    <div class="themeText">{{$t('product.sea')}}</div>
                </div>
                <div class="themeItem hv" @click="openPage('Land');">
                    <el-image
                        class="themeImg"
                         :src="$store.state.isPC?require('@/assets/img/land.png'):require('@/assets/img/land1.png')"
                        fit="contain">
                    </el-image>
                    <div class="themeText">{{$t('product.land')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	data () {
		return {
		}
	},
	mounted(){
	},
	methods:{
        openPage(type){
            if(type=='Ancient'){
                this.ga.event('productLine', 'click', 'Ancient');
                fbq('track', 'viewContent',{content_name:'Ancient'});
                this.$router.push('/LineDetail/30');
            }else if(type=='Sea'){
                this.ga.event('productLine', 'click', 'Sea');
                fbq('track', 'viewContent',{content_name:'Sea'});
                this.$router.push('/LineDetail/20');
            }else if(type=='Land'){
                this.ga.event('productLine', 'click', 'Land');
                fbq('track', 'viewContent',{content_name:'Land'});
                this.$router.push('/LineDetail/10');
            }
        }
	}
}
</script>
<style scoped>
	/*productLine*/
    .productLine{
        width: 100%;height: auto;position: relative;
    }
    .lineTitle{
        color: #484848;
    }
    .theme{
        width: 100%;height: calc(100% - 130px);display: flex;
        align-items:flex-end;justify-content: space-between;
    }
    .themeItem{
        position: relative;width: 33%;height: 100%;
    }
    .themeImg{height:100%;}
    .themeText{
        width: 88%;height: 70px;line-height: 70px;font-size: calc( 100vw / 1920 * 50);
        position: absolute;z-index: 2;text-align: center;bottom: 25%;left: 6%;color: #fff;
    }
	/*手机*/
    @media screen and (max-width: 767px){
        .lineContent{width: 80%;position: absolute;left: 10%;top: 0;height: 100%;}
        .theme{
            width:100%;display:block;height:auto;
        }
        .themeItem{width:100%;height:auto;margin-bottom:5%;}
        .productLine{
            width: 100%;height: auto;position: relative;
        }
        .themeText{
            bottom: 8%;font-size:24px;
        }
    }
    /*平板*/
    @media screen and (min-width: 768px) and (max-width: 992px){
		/*productLine*/
        .lineContent{
            position: absolute;left: 5%;top: 0;
            width: 90%;height: 100%;display: flex;flex-direction: column;align-content: center;
        }
        .productLine{
            width: 100%;height: auto;position: relative;
        }
        .themeText{
            bottom: 14%;font-size:28px;
        }
        .theme{
            height: calc(100% - 100px);
        }
    }
    /*中等屏幕*/
    @media screen and (min-width: 992px) and (max-width: 1200px){
    	/*productLine*/
        .lineContent{
            position: absolute;left: 10%;top: 0;
            width: 80%;height: 100%;display: flex;flex-direction: column;align-content: center;
        }
        .productLine{
            width: 100%;height: auto;position: relative;
        }
        .themeText{
            bottom: 16%;
        }
    }
    /*大屏幕*/
    @media screen and (min-width: 1200px){
        .lineContent{
            width: 90%;
            max-width: 1200px;
            position: absolute;
            left: 50%;
            margin-left: -600px;
            top: 0;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-content: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/common/ProductLine.vue